import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { FaTrash, FaEdit } from 'react-icons/fa';

import '../../src/createAdmin.css';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    IconButton,
    InputAdornment,
    Tooltip,
    CircularProgress
} from "@mui/material";
import { Button } from '@mui/material';
import * as XLSX from 'xlsx'; // Import the XLSX library
import { toast } from "react-toastify";
import { fetchTeamDetails, addTeam, editTeam, deleteTeam } from "../api/teamsApi";
import { getApiErrorMessage } from "../utils/apiError";



const CreateTeam = () => {

    const [AdminDetails, setAdmin] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    // starts true so the first paint is the skeleton, never an empty table
    const [loading, setLoading] = useState(true);


    const [open, setOpen] = useState(false);
    const [Name, setName] = useState("");
    const [nameError, setNameError] = useState("");

    const [add, setAdd] = useState(false);
    const [editTeamId, seteditTeamId] = useState();

    const [teamToDelete, setTeamToDelete] = useState(null);
    const [deleting, setDeleting] = useState(false);
    // name as the row was opened — used to detect edits
    const [initialName, setInitialName] = useState("");

    const GROUP_NAME_MAX_LENGTH = 150;
    const GROUP_NAME_DISPLAY_LIMIT = 30;
    const PAGE_SIZE = 10;
    const TABLE_COLUMNS = 5;

    // the delete button's footprint, reserved even when it is not rendered
    const ACTION_CELL_STYLE = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
    };
    const ACTION_PLACEHOLDER_STYLE = {
        display: 'inline-block',
        width: '34px',
        height: '26px',
    };

    const truncateName = (name) => {
        if (!name) {
            return "";
        }
        return name.length > GROUP_NAME_DISPLAY_LIMIT
            ? `${name.slice(0, GROUP_NAME_DISPLAY_LIMIT)}...`
            : name;
    };

    // Top-right, auto dismiss, solid green/red background
    const TOAST_OPTIONS = {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
    };

    const validateName = (value) => {
        const trimmed = value.trim();
        if (!trimmed) {
            return "Group Name cannot be empty or contain only spaces.";
        }
        if (value.length > GROUP_NAME_MAX_LENGTH) {
            return `Group Name cannot exceed ${GROUP_NAME_MAX_LENGTH} characters.`;
        }
        return "";
    };


    const navigate = useNavigate();

    const getTeams = async (page = 1) => {
        setLoading(true);
        try {
            const data = await fetchTeamDetails(page, 10);
            console.log(data, "data")

            setAdmin(Array.isArray(data?.data?.data) ? data.data.data : []);
            setTotalPages(data?.data?.totalPages || 1);
            setCurrentPage(data?.data?.currentPage || page);
        } catch (error) {
            console.error('Error fetching wallets:', error);
            // fall through to the No Data state instead of stale rows
            setAdmin([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getTeams(currentPage);
    }, [currentPage]);




    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const handleBackClick = () => {
        navigate('/dashboard');
    };

    const formatDate = (dateString) => {
        if (!dateString) {
            return '';
        }

        const date = new Date(dateString);

        if (isNaN(date)) {
            return 'Invalid Date';
        }

        const options = {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
        };

        return date.toLocaleString('en-GB', options).replace(',', '');
    };

    const convertToCSV = (data) => {
        const header = ["Phone Number", "Cumulated Recharge", "Cumulated Winning", "Cumulated Withdrawal", 'Updated At'];
        const rows = data.map(wallet => [
            wallet.user.mobile,
            wallet.cumulated_recharge,
            wallet.cumulated_winning,
            wallet.cumulated_widthraw,
            wallet.totaltdsDiducted

        ]);

        // Combine header and rows
        const csvContent = [
            header.join(","),  // Join header array into a single string
            ...rows.map(row => row.join(","))
        ].join("\n");  // Join all rows by a newline character

        return csvContent;
    };

    const downloadCSV = () => {
        const csvContent = convertToCSV(AdminDetails);

        // Create a Blob from the CSV content
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

        // Create a link element to trigger the download
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);

        link.setAttribute("href", url);
        link.setAttribute("download", "wallet_data.csv");  // Set filename
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();  // Trigger the download
        document.body.removeChild(link);
    };

    // Function to download Excel
    const downloadExcel = () => {
        const header = ["ID", "Admin Name", "Admin Email", "Admin Phone Number", 'Created At', ''];
        const rows = AdminDetails.map(wallet => ({
            "Phone Number": wallet.user.mobile,
            "Cumulated Recharge": wallet.cumulated_recharge,
            "Cumulated Winning": wallet.cumulated_winning,
            "Cumulated Withdrawal": wallet.cumulated_widthraw,
            'Total Tds Diduceted': wallet.totaltdsDiducted

        }));

        // Create a new workbook
        const ws = XLSX.utils.json_to_sheet(rows, { header }); // Create a sheet from JSON data
        const wb = XLSX.utils.book_new(); // Create a new workbook
        XLSX.utils.book_append_sheet(wb, ws, "Wallet Data"); // Append the sheet to the workbook

        // Write the workbook and trigger the download
        XLSX.writeFile(wb, "wallet_data.xlsx"); // This will download the Excel file
    };


    // Only opens the confirmation dialog — no API call yet
    const handleDeleteClick = (data) => {
        setTeamToDelete(data);
    };

    // Cancel: close the dialog, nothing is deleted
    const handleDeleteCancel = () => {
        if (deleting) {
            return;
        }
        setTeamToDelete(null);
    };

    const handleDeleteAdmin = async () => {
        const data = teamToDelete;
        if (!data) {
            return;
        }

        setDeleting(true);
        try {
            let payload = {
                teamId: data.id,
            };

            console.log(payload, "payload");
            const result = await deleteTeam(payload);

            if (result?.success === false) {
                toast.error(result?.message || "Failed to delete group, please try again.", TOAST_OPTIONS);
                return;
            }

            if (result) {
                // Delete success notification displayed with a red toast
                toast.error(result?.message || "Group deleted successfully", TOAST_OPTIONS);

                getTeams(currentPage);
                setAdmin((prev) => prev.filter((admin) => admin.id !== data.id));
            }

            setTeamToDelete(null);
        } catch (err) {
            console.error("Delete group failed:", err);
            toast.error(getApiErrorMessage(err, "Failed to delete group, please try again."), TOAST_OPTIONS);
        } finally {
            setDeleting(false);
        }
    };

    // Save stays off until the name actually changed (trailing spaces are
    // not an edit — the payload is trimmed)
    const isNameDirty = Name.trim() !== (initialName || "").trim();

    const handleClickOpen = (data, check) => {
        console.log(data, "data edit");
        setOpen(true);
        setNameError("");
        if (check === "add") {
            setName("");
            setInitialName("");
            setAdd(true);
        } else {
            setName(data.name);
            setInitialName(data.name || "");
            setAdd(false);
            seteditTeamId(data.id);
        }
    };

    const handleClose = () => {
        setOpen(false);
        setAdd(false);
        setName("");
        setInitialName("");
        setNameError("");
    };

    const addteam = async () => {
        try {
            const validationMessage = validateName(Name);
            if (validationMessage) {
                setNameError(validationMessage);
                return;
            }

            let payload = {
                name: Name.trim(),
            };
            const data = await addTeam(payload);

            // Some endpoints answer 200 with success:false + a message
            if (data?.success === false) {
                toast.error(data?.message || "Failed to add group, please try again.", TOAST_OPTIONS);
                return;
            }

            if (data) {
                // Create success notification displayed with a green success toast
                toast.success(data?.message || "Group created successfully", TOAST_OPTIONS);
                getTeams(currentPage);
            }

            handleClose();
        } catch (err) {
            console.error("Add group failed:", err);
            toast.error(getApiErrorMessage(err, "Failed to add group, please try again."), TOAST_OPTIONS);
        }
    };

    const editteam = async () => {
        try {
            const validationMessage = validateName(Name);
            if (validationMessage) {
                setNameError(validationMessage);
                return;
            }

            let payload = {
                name: Name.trim(),
                teamId: editTeamId,
            };
            const data = await editTeam(payload);

            if (data?.success === false) {
                toast.error(data?.message || "Failed to update group, please try again.", TOAST_OPTIONS);
                return;
            }

            if (data) {
                // Update success notification displayed with a green success toast
                toast.success(data?.message || "Group updated successfully", TOAST_OPTIONS);
                getTeams(currentPage);
            }

            handleClose();
        } catch (err) {
            console.error("Edit group failed:", err);
            toast.error(getApiErrorMessage(err, "Failed to update group, please try again."), TOAST_OPTIONS);
        }
    };






    return (
        <div>
            <h1>My Groups</h1>
            <Button
                variant="contained"
                color="secondary"
                onClick={handleBackClick}
                sx={{ marginBottom: 2 }}
            >
                Back to Dashboard
            </Button>
            {/* <Button
                variant="contained"
                color="primary"
                onClick={downloadCSV}
                sx={{ marginLeft: 7, marginBottom: 2 }}
            >
                Download CSV
            </Button>
            <Button
                variant="contained"
                color="primary"
                onClick={downloadExcel}
                sx={{ marginLeft: 7, marginBottom: 2 }}
            >
                Download Excel
            </Button> */}
            <Button
                variant="contained"
                color="primary"
                onClick={() => handleClickOpen("", "add")} sx={{ marginLeft: 10, marginBottom: 2, float: 'right' }}
            >
                Create Group
            </Button>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
                <thead>
                    <tr>
                        <th>S.No.</th>
                        <th>Group Name</th>
                        <th>Created At</th>
                        <th>Updated At</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        // Loader stays until the response lands
                        <tr>
                            <td colSpan={TABLE_COLUMNS} style={{ textAlign: "center", padding: "40px" }}>
                                <CircularProgress size={40} />
                            </td>
                        </tr>
                    ) : AdminDetails.length > 0 ? (
                        AdminDetails.map((AdminDetails, index) => (
                            <tr key={index}>
                                <td>{(currentPage - 1) * PAGE_SIZE + index + 1}</td>
                                <td>
                                    <Tooltip title={AdminDetails.name || ""}>
                                        <span>{truncateName(AdminDetails.name)}</span>
                                    </Tooltip>
                                </td>
                                <td>{formatDate(AdminDetails.createdAt)}</td>
                                <td>{formatDate(AdminDetails.updatedAt)}</td>
                                <td>
                                    {/* fixed two-slot layout so the edit icon sits in the
                                        same place whether or not delete is available */}
                                    <div style={ACTION_CELL_STYLE}>
                                        {/* Edit Button */}
                                        <button
                                            onClick={() => handleClickOpen(AdminDetails, "edit")} // define handleEdit
                                            style={{
                                                background: 'blue',
                                                color: 'white',
                                                margin: 0,
                                                border: 'none',
                                                padding: '6px 10px',
                                                borderRadius: '5px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <FaEdit />
                                        </button>

                                        {/* Delete Button — hidden for default or global groups,
                                            but its slot is kept so rows stay aligned */}
                                        {!(AdminDetails.isDefaultTeam || AdminDetails.isGlobal) ? (
                                            <button
                                                onClick={() => handleDeleteClick(AdminDetails)} // asks for confirmation first
                                                style={{
                                                    background: 'red',
                                                    color: 'white',
                                                    margin: 0,
                                                    border: 'none',
                                                    padding: '6px 10px',
                                                    borderRadius: '5px',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                <FaTrash />
                                            </button>
                                        ) : (
                                            <span style={ACTION_PLACEHOLDER_STYLE} />
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={TABLE_COLUMNS} style={{ textAlign: "center", padding: "20px" }}>
                                No Data Available
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <div>
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={loading || currentPage === 1}>
                    Previous
                </button>
                <span> Page {currentPage} of {totalPages} </span>
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={loading || currentPage === totalPages}>
                    Next
                </button>
            </div>

            <div>
                <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
                    <DialogTitle sx={{ fontWeight: 'bold' }}>{add ? "Add Group" : "Edit Group"}</DialogTitle>
                    <DialogContent>
                        <TextField
                            label="Name"
                            type="text"
                            fullWidth
                            value={Name}
                            onChange={(e) => {
                                const value = e.target.value;
                                setName(value);
                                setNameError(validateName(value));
                            }}
                            sx={{ mt: 2 }}
                            inputProps={{ maxLength: GROUP_NAME_MAX_LENGTH }}
                            error={Boolean(nameError)}
                            helperText={nameError || `${Name.length}/${GROUP_NAME_MAX_LENGTH} characters`}
                            FormHelperTextProps={{ sx: { textAlign: 'right' } }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="secondary">
                            Cancel
                        </Button>
                        {/* <Button onClick={addteam} color="primary" variant="contained">
                            Confirm
                        </Button> */}

                        {add ? (
                            <Button onClick={addteam} color="primary" variant="contained" disabled={Boolean(validateName(Name))}>
                                Add
                            </Button>
                        ) : (
                            <Button
                                onClick={editteam}
                                color="primary"
                                variant="contained"
                                disabled={Boolean(validateName(Name)) || !isNameDirty}
                            >
                                Save
                            </Button>
                        )}
                    </DialogActions>
                </Dialog>
            </div>

            {/* Delete confirmation — the API runs only from here */}
            <Dialog open={Boolean(teamToDelete)} onClose={handleDeleteCancel} fullWidth maxWidth="xs">
                <DialogTitle sx={{ fontWeight: 'bold' }}>Delete Group</DialogTitle>
                <DialogContent>
                    <p style={{ margin: 0 }}>
                        Are you sure you want to delete this group?
                    </p>
                    {teamToDelete?.name && (
                        <p style={{ marginBottom: 0, fontWeight: 'bold', wordBreak: 'break-word' }}>
                            {teamToDelete.name}
                        </p>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteCancel} color="secondary" disabled={deleting}>
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteAdmin} color="error" variant="contained" disabled={deleting}>
                        {deleting ? "Deleting..." : "Delete"}
                    </Button>
                </DialogActions>
            </Dialog>



        </div>
    );

}

export default CreateTeam;
